import React from 'react';
import Hero from '../components/Hero';
import Activities from '../components/Activities';
import Story from '../components/Story';
import Courses from '../components/Courses';
import Stats from '../components/Stats';
import WhyChoose from '../components/WhyChoose';
import AcademicCalendar from '../components/AcademicCalendar';
import Testimonials from '../components/Testimonials';
import SEO from '../components/SEO';

const Home = () => {
  return (
    <div className="animate-fadeIn">
      <SEO page="home" />
      <Hero />
      <Activities />
      <Story />
      <Courses />
      <Stats />
      <WhyChoose />
      <AcademicCalendar />
      <Testimonials />
    </div>
  );
};

export default Home;